import React from 'react'
import styles from '../styles/Reviews.module.scss'

export const NotContactMeOrMaybeLatterStep: React.FC = () => {

  return (
    <div className={styles.thank_you}>
      <img src="/unhappy_people.svg" alt="Unhappy people"/>

      <p className={styles.thank_you_text}>
        We are really sorry that <br/>
        we made you feel that way.
      </p>

      <p className={styles.thank_you_text}>
        We are always trying to improve  <br/>
        and thank you for your feedback.
      </p>
    </div>
  )
}